import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';
import { SnackService } from '../../../shared-services/snack.service';

@Component({
    selector: 'app-modal-link-confirmacion',
    styleUrls: ['./modal-link-confirmacion.component.scss'],
    templateUrl: './modal-link-confirmacion.component.html',
})
export class ModalLinkConfirmacionComponent {
    public link: string;
    public linkString: string;

    okButtonTextLabel = 'Aceptar';
    cancelButtonTextLabel = 'Cancelar';

    constructor(
        public dialogRef: MatDialogRef<ModalLinkConfirmacionComponent>,
        public snackService: SnackService) {}

    public set okButtonText(value: string)  {
      this.okButtonTextLabel = value;
    }

    public set cancelButtonText(value: string) {
      this.cancelButtonTextLabel = value;
    }

    copiarLink() {
        const selBox = document.createElement('textarea');
        selBox.value = this.link;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        const copiado = document.execCommand('copy');
        document.body.removeChild(selBox);
        if (copiado) {
            this.snackService.success('Link copiado al portapapeles');
        } else {
            this.snackService.error('Hubo un error al copiar');
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/link-confirmacion/modal-link-confirmacion.component.ts